import { render } from "./AddRoomate.vue?vue&type=template&id=408520dc&scoped=true"
import script from "./AddRoomate.vue?vue&type=script&lang=js"
export * from "./AddRoomate.vue?vue&type=script&lang=js"

import "./AddRoomate.vue?vue&type=style&index=0&id=408520dc&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408520dc"]])

export default __exports__